<template>
    <div v-if="isVisible(node)" class="step-node card mb-3" :class="cardClass">
        <div class="card-body">
            
            <div class="d-flex align-items-start justify-content-between">
                <div class="pr-2">
                    <div class="font-weight-bold mb-2">
                        {{ node.title }}
                    </div>
                    
                    <div v-if="node.description" class="text-muted small mb-2">
                        {{ node.description }}
                    </div>
                </div>
                
                <div class="text-muted small ml-2" v-if="indexLabel">
                    {{ indexLabel }}
                </div>
            </div>
            
            <b-form-radio-group
                :id="'q-' + node.id"
                :name="'q-' + node.id"
                :value="answerValue"
                @input="onAnswerInput"
                button-variant="outline-primary"
                :options="yesNoOptions"
                buttons
                class="mt-1"
            />
            
            <div v-if="showErrors && (answerValue !== true && answerValue !== false)"
                 class="text-danger small mt-2">
                Будь ласка, оберіть відповідь.
            </div>
            
            <div v-if="commentVisible" class="mt-3">
                <div v-if="node.comment_description" class="text-muted small mb-1">
                    {{ node.comment_description }}
                </div>
                
                <b-form-textarea
                    :value="commentValue"
                    @input="onCommentInput"
                    rows="3"
                    max-rows="6"
                    placeholder="Вкажіть коментар..."
                />
                
                <div v-if="showErrors && commentRequired && !commentOk"
                     class="text-danger small mt-2">
                    Коментар обов’язковий.
                </div>
            </div>
        
        </div>
        
        <div v-if="hasChildren" class="px-3 pb-3">
            <StepNode
                v-for="child in node.children"
                :key="child.id"
                :node="child"
                :answers="answers"
                :yesNoOptions="yesNoOptions"
                :isVisible="isVisible"
                :isCommentRequired="isCommentRequired"
                :showErrors="showErrors"
                :indexMap="indexMap"
                @setAnswer="$emit('setAnswer', ...arguments)"
                @setComment="$emit('setComment', ...arguments)"
            />
        </div>
    
    </div>
</template>

<script>
export default {
    name: 'StepNode',
    
    props: {
        node: { type: Object, required: true },
        answers: { type: Object, required: true },
        yesNoOptions: { type: Array, required: true },
        isVisible: { type: Function, required: true },
        isCommentRequired: { type: Function, required: true },
        showErrors: { type: Boolean, default: false },
        indexMap: { type: Object, default: () => ({}) },
    },
    
    methods: {
        onAnswerInput(value) {
            this.$emit('setAnswer', this.node.id, value);
        },
        
        onCommentInput(comment) {
            this.$emit('setComment', this.node.id, comment);
        }
    },
    
    computed: {
        answerValue() {
            const row = this.answers[this.node.id];
            return row ? row.value : null;
        },
        
        commentValue() {
            const row = this.answers[this.node.id];
            return row ? (row.comment || '') : '';
        },
        
        commentRequired() {
            return this.isCommentRequired(this.node);
        },
        
        commentVisible() {
            return this.commentRequired;
        },
        
        commentOk() {
            return String(this.commentValue || '').trim().length > 0;
        },
        
        hasChildren() {
            return Array.isArray(this.node.children) && this.node.children.length > 0;
        },
        
        cardClass() {
            if (!this.showErrors) return '';
            const answerMissing = (this.answerValue !== true && this.answerValue !== false);
            const commentMissing = (this.commentRequired && !this.commentOk);
            return (answerMissing || commentMissing) ? 'border-danger' : '';
        },
        
        indexLabel() {
            const idx = this.indexMap && this.indexMap[this.node.id];
            return idx ? `#${idx}` : '';
        }
    },

}
</script>

<style scoped>
.step-node.border-danger {
    border-width: 2px !important;
}
</style>